﻿import {ElementNode, DOMExportOutput, EditorConfig, LexicalNode, NodeKey, SerializedElementNode} from "lexical";

export type SerializedVideoNode = SerializedElementNode & {
    type: 'video';
    version: 1;
    src: string;
};

export class VideoNode extends ElementNode {
    src: string;

    constructor(src: string, key?: NodeKey) {
        super(key);
        this.src = src;
    }

    static getType(): string {
        return 'video';
    }

    static clone(node: VideoNode): VideoNode {
        return new VideoNode(node.src, node.__key);
    }

    static importJSON(serializedNode: SerializedVideoNode): VideoNode {
        const {src} = serializedNode;
        return new VideoNode(src);
    }

    exportJSON(): SerializedVideoNode {
        return {
            ...super.exportJSON(),
            type: 'video',
            version: 1,
            src: this.src,
        };
    }

    createDOM(): HTMLElement {
        const container = document.createElement("div");
        container.className = "video-node";

        const video = document.createElement("video");
        video.src = this.src;
        video.controls = true;
        video.style.maxWidth = "100%";

        container.appendChild(video);
        return container;
    }

    updateDOM(): boolean {
        return false;
    }
}

export function $createVideoNode(src: string): VideoNode {
    return new VideoNode(src);
}

export function $isVideoNode(node?: LexicalNode | null): node is VideoNode {
    return node instanceof VideoNode;
}
